import { resolveRpcHost } from './host-resolution';

declare const iamSession: string;

function getSessionToken(): string | null {
  if (typeof iamSession !== 'undefined' && iamSession) return iamSession;
  try {
    return localStorage.getItem('local_session');
  } catch {
    return null;
  }
}

function getEnvironment(): string {
  return (globalThis as Record<string, unknown>)['environment'] as string || 'prod';
}

export async function fetchRpc<T>(path: string, body: unknown): Promise<T> {
  const env = getEnvironment();
  const host = resolveRpcHost(path, env);
  const token = getSessionToken();

  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const resp = await fetch(`${host}/${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });

  if (!resp.ok) {
    throw new RpcError(resp.status, await resp.text());
  }

  return resp.json() as T;
}

export class RpcError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: string,
  ) {
    super(`RPC failed with status ${status}: ${body}`);
    this.name = 'RpcError';
  }
}
